import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { Box, Tabs, Tab } from '@mui/material'
import { UNASSIGNED_ROUTE } from 'containers/new-route-manager/settings'

/**
 * Route filter component using MUI Tabs for accessibility
 * Provides keyboard navigation and ARIA support
 */
const RouteFilter = ({ selectedRoute, uniqueRoutes, routeCounts, onRouteChange }) => {
  const handleTabChange = useCallback(
    (event, newValue) => {
      onRouteChange(newValue)
    },
    [onRouteChange]
  )

  return (
    <Box>
      <Tabs
        value={selectedRoute}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="Route filter tabs"
        sx={{
          minHeight: 40,
          '& .MuiTab-root': {
            minHeight: 40,
            textTransform: 'none',
            fontWeight: 400,
          },
        }}
      >
        <Tab value="All" label={`All (${routeCounts.All || 0})`} id="route-tab-all" aria-controls="route-tabpanel-all" />
        <Tab
          value={UNASSIGNED_ROUTE.id}
          label={`${UNASSIGNED_ROUTE.name} (${routeCounts[UNASSIGNED_ROUTE.id] || 0})`}
          id="route-tab-unassigned"
          aria-controls="route-tabpanel-unassigned"
        />
        {uniqueRoutes.map(route => (
          <Tab
            key={route.id}
            value={route.id}
            label={`${route.name} (${routeCounts[route.id] || 0})`}
            id={`route-tab-${route.id}`}
            aria-controls={`route-tabpanel-${route.id}`}
          />
        ))}
      </Tabs>
    </Box>
  )
}

RouteFilter.propTypes = {
  selectedRoute: PropTypes.string.isRequired,
  uniqueRoutes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  routeCounts: PropTypes.object.isRequired,
  onRouteChange: PropTypes.func.isRequired,
}

export default RouteFilter
